import React, { useEffect, useState } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faTrash,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../common/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { EnterpriseService } from "../../service/enterprise.service";
import { Enterprise } from "../../model/enterprise.model";
import { OrdersService } from "../../service/orders.service";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";
import ApprovalTwoToneIcon from '@mui/icons-material/ApprovalTwoTone';
import BlockTwoToneIcon from '@mui/icons-material/BlockTwoTone';
import TimerTwoToneIcon from '@mui/icons-material/TimerTwoTone';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { Autocomplete, IconButton, MenuItem, TextField } from "@mui/material";
import { DataGrid, GridApi, GridCellParams, GridColDef, GridColumnHeaderParams, gridClasses } from "@mui/x-data-grid";
import useAutocomplete from '@mui/base/useAutocomplete';
//import {Helmet} from "react-helmet";

function OrdersNotifications() {
  const pageNumberLimit = 5;
  const enterpriseSvc = new EnterpriseService();
  const ordersSvc = new OrdersService();
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageLimit, setMaxPageLimit] = useState(5);
  const [minPageLimit, setMinPageLimit] = useState(0);
  //const { brandsList } = useSelector((state: any) => state.brandSlice);
  const [noOfEntries, setnoOfEntries] = useState(25);
  // const dispatch = useDispatch();
  const [searchedVal, setSearchedVal] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [filteredOrderList, setFilteredOrderList] = useState<any[]>([]);
  const [selectedEnterprise, setSelectedEnterprise] = useState(1);
  const [availableEnterprise, setAvailableEnterprise] = useState<Enterprise[]>([]);
  const [selectedStatus, setSelectedStatus] = useState("99");
  const [ordersData, setOrdersData] = useState<any[]>([]);
  const [filteredOrders, setFilteredOrders] = useState<any[]>([]);

  
   const [selectedEntOption, setselectedEntOption] = useState<Enterprise>();

  //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);

  const navigate = useNavigate();

  const loadAllEnterprises = () => {
    enterpriseSvc.getActiveEnterprisesList().then(data => {
      const res = data.data;     

      const allent ={entId: 1, entName: "All"};
      const newRes:any[] = [];
      newRes.push(allent);
      newRes.push(...data.data);
           
      setAvailableEnterprise(newRes);
     // setselectedEntOption(newRes[1])      

    });
  }


  //useEffect(() => {
  const submitRequest = (checkApprovalStatus: number) => {
    if (selectedEnterprise > 0 ) {
      ordersSvc.getOrdersList(currentPage, noOfEntries, Number(selectedEnterprise), checkApprovalStatus).then(res => {
        if (res.data && res.data[0]) {
          if (res.status == 100) {

            let cnt1 = 0;
            const peopleWithImages = res.data[0].list.map((person: any, index: any) => {
              var id = person.Id. split("/").pop();

              var entId = person.Id. split("/")[1];

              var approvalStatus = person.approvalStatus;  

           
              var apprStatusValue = "Pending"
              if (person.approvalStatus == "-1") {
                apprStatusValue = "Pending";
              } else if (person.approvalStatus == "0") {
                apprStatusValue = "Rejected";
              } else if (person.approvalStatus == "1") {
                apprStatusValue = "Approved";
              }


              const objInfo = {id , entId ,approvalStatus } 

              cnt1 = cnt1 + 1;
              return {
                ...person,
                apprStatus : apprStatusValue,
                id: cnt1,
                download:objInfo,
                action:objInfo // person.Id,
              };

            });


            setOrdersData(peopleWithImages);
            // setTotalPages(res.data[0].itemList.length / noOfEntries);
            let totalPgs = Math.ceil(res.data[0].list.length / noOfEntries);
            setTotalPages(totalPgs);
          } else {
            // setFilteredOrders([]);
            setOrdersData([]);
            toast.error("No Data Available", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 2000,
              hideProgressBar: true,
            });
          }

        } else {
          setOrdersData([]);
        }
      })
    }
  }//, [selectedEnterprise, selectedStatus]);



  useEffect(() => {
    if (ordersData) {
      const start = (currentPage - 1) * noOfEntries;
      let ordersList = ordersData.slice(start, start + noOfEntries);
      setFilteredOrders([...ordersList]);
    }
  }, [currentPage, ordersData])


  
  const location = useLocation();


  let loaddatacalled = false;
  useEffect(() => {

    if (!loaddatacalled) {


      loaddatacalled = true;
      submitRequest(-1)
    }
  }, []);



  const getStatusType = (status: number) => {
    let statusIconBlock = "";
    if (status == -1) {
      statusIconBlock = "<Button disabled disableRipple style={{color:\"green\"}} className=\"mr-4\"  variant=\"text\" startIcon={<TimerTwoToneIcon />}> Approve</Button>";
    } else if (status == 0) {
      statusIconBlock = "<Button disabled disableRipple style={{color:\"green\"}} className=\"mr-4\"  variant=\"text\" startIcon={<BlockTwoToneIcon />}> Approve</Button>";
    } else if (status == 1) {
      statusIconBlock = "<Button disabled disableRipple style={{color:\"green\"}} className=\"mr-4\"  variant=\"text\" startIcon={<ApprovalTwoToneIcon />}> Approve</Button>";
    }
    return statusIconBlock;
  };

  const columns: GridColDef[] = [


    {
      field: 'Id', headerName: 'Order Id', width: 150,
    },
    {
      field: 'nName', headerName: 'Order Name', flex: 1,
    },
    {
      field: 'entName', headerName: 'Enterprise Name', flex: 1,


    },
    {
      field: 'entAddress', headerName: 'Enterprise Address', width: 250,


    },
    {
      field: 'transportName', headerName: 'Transport Name', flex: 1,

    },
    {
      field: 'OIN', headerName: 'ERP Order Id', flex: 1,


    },
    {
      field: 'apprStatus', headerName: 'Status', flex: 1,

      renderCell: (params) => {
        return <div>
          { 
               params.value == "Pending" && (<p style={{ color: "blue" }}>Pending</p>)
            || params.value == "Rejected" && (<p style={{ color: "red" }}>Rejected</p>)
            || params.value == "Approved" && (<p style={{ color: "green" }}>Approved</p>)
          }

        </div>
      }

    },

    {
      field: 'DateC', headerName: 'Created Date', flex: 1,


    },

    {
      filterable: false,
      width: 50,
      field: "action",
      headerName: "",
      sortable: false,
      renderCell: (params) => {
        const onClick = (e: { stopPropagation: () => void; }) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellParams> = {};

          api
            .getAllColumns()
            .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
            .forEach(
              (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
            );
        };

        return <div>
         {/* <Link to={`${(selectedEnterprise + "")}/${((params.value as string).split("/").pop())}/${selectedStatus + ""}`} */}
         <Link to={`${(params.value.entId + "")}/${((params.value.id as string).split("/").pop())}/${params.value.approvalStatus + ""}`}
            className="pr-4 text-dark">
            <IconButton ><EditTwoToneIcon fontSize="small" /></IconButton>
          </Link>
        </div>
      },

    }

  ];


  return (
    <div className="App border card">

      

 

      <div style={{ width: '100%'}}>
        <DataGrid

          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold"
            },
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: "#D0D0D0"
            },
            '& .Mui-odd': {
              textOverflow: "inherit", fontSize: "12px", textAlign: "left"
            },

            '& .Mui-even': {
              backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"

            },

            '& .Mui-cellown': {
              paddingTop: 2, paddingBottom: 2

            },

          }}

          getCellClassName={(params) => 'Mui-cellown'}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
          //  rowHeight={70}   
          autoHeight={true}
          getRowHeight={() => 'auto'}
          rows={ordersData}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 25, 50]}
       

        />
      </div>
      <ToastContainer />
    </div>
  );
}

export default OrdersNotifications;
